import React from 'react';
import classnames from 'classnames';
import { shouldShowErrors } from 'app/utils/forms';
import ValidationMessage from 'app/components/base/ValidationMessage';
import Dropdown from 'app/components/base/Dropdown';
import InlineLabel from 'app/components/base/InlineLabel';
import style from './style.css';

const labelIcon = {
  family: 'mozio',
  name: 'ic-error-1',
  error: true
};

const ErrorMessageDropdown = ({
  children,
  className,
  meta,
  size,
  validateWhenDirty,
  /* eslint-disable */
  input
  /* eslint-enable */
}) => (
  <Dropdown
    size={size}
    error
    childrenClassName={style.item}
    inline
    open={shouldShowErrors(meta, validateWhenDirty)}
    origin={children}
    className={classnames(style.container, className)}
  >
    <InlineLabel icon={labelIcon}>
      <ValidationMessage
        plain
        errorType={meta.error || meta.warning}
      />
    </InlineLabel>
  </Dropdown>
);

// TODO: move to Flow types
// ErrorMessageDropdown.propTypes = {
//   meta: PropTypes.object.isRequired,
//   size: PropTypes.string,
//   children: PropTypes.node,
//   className: PropTypes.string,
//   validateWhenDirty: PropTypes.string
// };

ErrorMessageDropdown.defaultProps = {
  size: 'noshrink'
};

export default ErrorMessageDropdown;
